import React, { useState } from 'react'
import Header from './Header'
import FooterBar from '../components/FooterBar'
import HeaderBar from '../components/HeaderBar'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { useIsDesktop } from '../hooks/useIsDesktop'

const OptionsContainer = styled.div`
  display: flex;
  width: 358px;
`;

// When rendering the "regular UI" inside the desktop shell, we suppress the mobile header/footer
// and widen common mobile frame containers (390px) to a desktop-friendly width.
const DesktopContentWrap = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  justify-content: center;
  align-items: stretch;

  /* widen the common mobile frames */
  .w-\\[390px\\],
  .max-w-\\[390px\\] {
    width: min(1200px, 100%) !important;
    max-width: 1200px !important;
  }
`;

export default function LayoutHeader({ children }) {
    const location = useLocation();
    const isDesktop = useIsDesktop();
    const isPromptsPage = location.pathname.startsWith('/prompts') || location.pathname.startsWith('/prompt-library');
    const isViewAllPage = location.pathname.includes('/view-all') ||
                         location.pathname === '/catalog' ||
                         location.pathname === '/bookings' ||
                         location.pathname === '/merch';
    const isActivityFeedPage = location.pathname === '/activity-feed';
    const isTimelineSettingsPage = location.pathname === '/timeline-settings';
    const isAddSectionPage = location.pathname.startsWith('/add-section');
    const isAnalyticsPage = location.pathname.startsWith('/analytics') || location.pathname.includes('/analytics');
    const isEditPage = location.pathname.includes('/edit/');
    const isTeamManagementPage = location.pathname.includes('/team-management');
    const isInnerFlowPage = location.pathname.includes('/bulk-import') || 
                           location.pathname.includes('/manual-add') || 
                           location.pathname.includes('/login-agency') ||
                           location.pathname.includes('/login-catalog') ||
                           location.pathname === '/catalog/import' ||
                           location.pathname.startsWith('/catalog/works') ||
                           location.pathname.startsWith('/bookings/ticket-counter');
    const isNewAppPage = location.pathname === '/charting' ||
                        location.pathname === '/playlisting' ||
                        location.pathname === '/social-listening' ||
                        location.pathname === '/spotify-revenue' ||
                        location.pathname.startsWith('/reminders') ||
                        location.pathname.startsWith('/flows');
    
    const isKnowledgeBasePage = location.pathname.startsWith('/knowledge-base');
    const isNotesPage = location.pathname.startsWith('/notes');
    const isConnectorsPage = location.pathname.startsWith('/connectors');
    const isTourManagerPage = location.pathname.startsWith('/tour-manager');
    const isContactsPage = location.pathname.startsWith('/contacts');
    const isTasksPage = location.pathname.startsWith('/tasks');
    const isDataPage = location.pathname.startsWith('/data');
    
    // Check if user is a team member (regardless of path)
    const getUserData = () => {
        try {
            const userData = localStorage.getItem('dizeeUser');
            return userData ? JSON.parse(userData) : null;
        } catch (error) {
            return null;
        }
    };
    
    const userData = getUserData();
    const isTeamMemberUser = userData && ['manager', 'agent', 'label', 'publisher', 'business-manager'].includes(userData.professionRole);
    
    const isTeamMemberPage = location.pathname === '/team-member-dashboard' ||
                            location.pathname === '/manager-dashboard' ||
                            location.pathname.startsWith('/team-member') ||
                            (location.pathname === '/' && isTeamMemberUser); // Hide footer on root path for team members

    // Check if we're on artist settings pages
    const isArtistSettingsPage = location.pathname.startsWith('/more/setting');

    // Check if we're on usage dashboard pages
    const isUsagePage = location.pathname.startsWith('/usage');

    // Check if we're on Email app pages
    const isEmailAppPage = location.pathname.startsWith('/email');

    // Desktop shell (DesktopLayout) already provides navigation + spacing.
    // We want the "regular" pages to render their content without the mobile header/footer frame.
    if (isDesktop) {
        return (
            <div className="h-full w-full bg-black">
                <DesktopContentWrap>{children}</DesktopContentWrap>
            </div>
        );
    }

    return (
        <div className='h-auto bg-black'>
            {/* <Header /> */}

            <div className="fixed top-0 w-full flex justify-center bg-[black] z-[25] border border-black">
                <OptionsContainer className="">
                    <HeaderBar isHome={false} />
                </OptionsContainer>
            </div>

            <div className='relative w-full text-[12px] pt-[80px] h-auto flex justify-center items-start bg-[black]'>
                {children}
            </div>

            {!isPromptsPage && !isViewAllPage && !isActivityFeedPage && !isTimelineSettingsPage && !isAddSectionPage && !isInnerFlowPage && !isAnalyticsPage && !isEditPage && !isNewAppPage && !isTeamManagementPage && !isTeamMemberPage && !isArtistSettingsPage && !isUsagePage && !isKnowledgeBasePage && !isNotesPage && !isEmailAppPage && !isConnectorsPage && !isTourManagerPage && !isContactsPage && !isTasksPage && !isDataPage && <FooterBar isHome={false} />}
        </div>
    )
}
